module.exports = __webpack_public_path__ + "img/quest_icon_0003_key.2f8f7fd4.png";